import { atom } from 'recoil';

export const gameProposalIdState = atom<number | null>({
  key: 'gameProposalIdState',
  default: null,
  effects: [
    ({ setSelf, onSet }) => {
      const savedValue = sessionStorage.getItem("gameProposalId");
      if (savedValue != null) {
        setSelf(Number(savedValue));
      }

      onSet((newValue) => {
        if (newValue === null) {
          sessionStorage.removeItem("gameProposalId");
        } else {
          sessionStorage.setItem("gameProposalId", String(newValue));
        }
      });
    },
  ],
}); 